webpackJsonp([35783957827783],{

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pallo_siluetti.478e4869.svg";

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(4);
	
	var _gatsbyImage = __webpack_require__(21);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Layout = __webpack_require__(12);
	
	var _colors = __webpack_require__(10);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _pallo_siluetti = __webpack_require__(95);
	
	var _pallo_siluetti2 = _interopRequireDefault(_pallo_siluetti);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var slidein = /*#__PURE__*/(0, _reactEmotion.keyframes)('0%{top:100%;}50%{top:40%;}100%{top:-200%;}'); /* eslint-disable no-undef, react/prop-types */
	
	
	var sway = /*#__PURE__*/(0, _reactEmotion.keyframes)('0%,20%,40%{transform:rotate(5deg);}10%,30%{transform:rotate(-5deg);}50%{transform:rotate(-2deg);}60%,80%,100%{transform:rotate(2deg);}70%,90%{transform:rotate(-2deg);}');
	
	var fadein = /*#__PURE__*/(0, _reactEmotion.keyframes)('0%{opacity 0;}75%{opacity 0;}100%{opacity 1;}');
	
	var mainStyle = /*#__PURE__*/(0, _reactEmotion.css)('opacity:1;animation:', fadein, ' 10s ease-in 1;text-align:center;p{width:50%;margin-left:auto;margin-right:auto;margin-bottom:1em;margin-top:1em;}');
	
	var palloStyleBG = /*#__PURE__*/(0, _reactEmotion.css)(':after{content:\' \';opacity:0.8;display:block;position:absolute;top:0;bottom:0;width:100%;height:100%;z-index:-1;background:url(', _pallo_siluetti2.default, ') no-repeat center;animation:', slidein, ' 10s ease-in-out forwards,', sway, ' 10s ease-in-out forwards;transform-origin:center 10%;}');
	
	var imgStyle = /*#__PURE__*/(0, _reactEmotion.css)('max-height:70vh;margin-left:10%;margin-right:10%;');
	var outerImgWrapper = /*#__PURE__*/(0, _reactEmotion.css)('margin-left:auto;margin-right:auto;margin-top:5.5rem;');
	
	var container = /*#__PURE__*/(0, _reactEmotion.css)('margin-left:10%;margin-right:10%;margin-top:8rem;.ytWrapper{position:relative;width:100%;height:0;padding-bottom:56.25%;.video{position:absolute;top:0;left:0;width:100%;height:100%;}}');
	
	var content = function content(_ref) {
	  var data = _ref.data;
	  var juliste = data.juliste;
	
	  return _react2.default.createElement(
	    'div',
	    { className: palloStyleBG },
	    _react2.default.createElement(
	      _Layout.Box,
	      { className: mainStyle },
	      _react2.default.createElement(_Layout.Box, {
	        width: [1, 1, 1 / 2],
	        m: ['0 0 0 0', '0 0 0 0', '0 auto 0 auto'],
	        px: [3, 3, 0],
	        color: _colors2.default.primary,
	        align: 'center'
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: container },
	        _react2.default.createElement(
	          'div',
	          { className: 'ytWrapper' },
	          _react2.default.createElement('iframe', { className: 'video', src: 'https://www.youtube.com/embed/gELEUdaIXLY', frameborder: '0', allow: 'autoplay; encrypted-media', allowfullscreen: true })
	        )
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/teoksesta' },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          className: imgStyle,
	          outerWrapperClassName: outerImgWrapper,
	          alt: 'Graafikko: Jussi-Pekka Koivisto',
	          sizes: juliste.childImageSharp.sizes,
	          imgStyle: { objectFit: 'contain', objectPosition: 'top center' }
	        })
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Yst\xE4vykset Tytti, Maija ja Franz tempautuvat el\xE4m\xE4ns\xE4 seikkailuun yritt\xE4ess\xE4\xE4n pelastaa Owlan ahneen Apteekkarin kynsist\xE4. Owlan valkea kaupunki kutsuu koko perheen mukaan suureen seikkailuun!'
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = content;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-6e9c65a356d059c93ff2.js